export default {
  headline: 'A Flexible Platform for Employees and Contractors',
  strapline: 'With the ability to set custom requirements for everyone on the team, anyone from a part-time contractor to a full-time lifer can get a bit of encouragement from Harvey.',
  ctaLabel: 'Fork on GitHub'
};